import { render, staticRenderFns } from "./crm-update_department.vue?vue&type=template&id=2b1c99e6&"
import script from "./crm-update_department.vue?vue&type=script&lang=js&"
export * from "./crm-update_department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports